module.exports = __webpack_public_path__ + "static/media/travel.191da8ce.png";